import mediaUrl from "../../utils/mediaUrl";
import React, { useEffect, useState } from "react";
import Footer from "../Footer";
import Header from "../Header";

import "../../assets/css/course_overview.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faClock,
	faDownload,
	faFileAlt,
	faKey,
	faLanguage,
	faRibbon,
	faTv,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import auth from "../../utils/auth";
import track from "../../utils/track";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { IonPage } from "@ionic/react";
import Swal from "sweetalert2";

// Maps the admin's icon keyword (Course.includes[].icon) to a FontAwesome icon.
const INCLUDE_ICONS = {
	clock: faClock,
	download: faDownload,
	language: faLanguage,
	key: faKey,
	tv: faTv,
	file: faFileAlt,
	ribbon: faRibbon,
};

// Shown only if a course has no `includes` set.
const DEFAULT_INCLUDES = [
	{ icon: "clock", label: "15 mins of animated video" },
	{ icon: "download", label: "1 downloadable resource" },
	{ icon: "language", label: "English and Hindi" },
	{ icon: "key", label: "Full lifetime access" },
	{ icon: "tv", label: "Access on mobile and PC" },
	{ icon: "file", label: "Worksheet" },
	{ icon: "ribbon", label: "Certificate of Completion" },
];

const CourseOverview = (props) => {
	const [isOpaque, setIsOpaque] = useState(true);
	const [course, setCourse] = useState({});
	const [activeTab, setActiveTab] = useState("overview");
	const params = useParams();
	const [enrolled, setEnrolled] = useState(false);
	const [enrolling, setEnrolling] = useState(false);
	const [linkCopied, setLinkCopied] = useState(false);

	const copyCourseLink = () => {
		const done = () => {
			setLinkCopied(true);
			setTimeout(() => setLinkCopied(false), 2000);
		};
		if (navigator.clipboard && navigator.clipboard.writeText) {
			navigator.clipboard.writeText(window.location.href).then(done).catch(done);
		} else {
			const ta = document.createElement("textarea");
			ta.value = window.location.href;
			document.body.appendChild(ta);
			ta.select();
			document.execCommand("copy");
			document.body.removeChild(ta);
			done();
		}
	};
	const [related, setRelated] = useState([]);
	const config = {
		headers: {
			"Content-Type": "application/json",
			"x-auth-token": auth.getToken(),
		},
	};

	const navigate = useNavigate();
	const { pathname } = useLocation();

	function loadScript(src) {
		return new Promise((resolve) => {
			const script = document.createElement("script");
			script.src = src;
			script.onload = () => {
				resolve(true);
			};
			script.onerror = () => {
				resolve(false);
			};
			document.body.appendChild(script);
		});
	}

	async function displayRazorpay() {
		// const res = await loadScript(
		// 	"https://checkout.razorpay.com/v1/checkout.js"
		// );

		// console.log(res);

		// if (!res) {
		// 	showToast("Razorpay SDK failed to load. Are you online?", "error");
		// 	return;
		// }

		// const result = await axios.get(
		// 	`${process.env.REACT_APP_API_URL}api/payments/course/${params.courseID}`,
		// 	config
		// );

		// const { amount, id: order_id, currency } = result.data;

		// const options = {
		// 	key: process.env.REACT_APP_RAZORPAY_KEY, // Enter the Key ID generated from the Dashboard
		// 	amount: amount,
		// 	currency: currency,
		// 	name: "Wyden",
		// 	description: course.name,
		// 	order_id: order_id, //This is a sample Order ID
		// 	handler: async function (response) {
		// 		const data = {
		// 			orderID: order_id,
		// 			razorpayPaymentID: response.razorpay_payment_id,
		// 			razorpayOrderID: response.razorpay_order_id,
		// 			razorpaySignature: response.razorpay_signature,
		// 		};

		// 		console.log(response);

		// 		const res = axios
		// 			.post(`/courses/${params.courseID}/enroll`, data, config)
		// 			.then((res) => {
		// 				setEnrolled(true);
		// 				showToast("Successfully Enrolled", "success");
		// 			})
		// 			.catch((e) => {
		// 				showToast(
		// 					e.response?.data.message || "Something went wrong",
		// 					"error"
		// 				);
		// 			});
		// 	},
		// 	prefill: {
		// 		name: auth.getUserInfo().name,
		// 		email: auth.getUserInfo().email,
		// 		contact: auth.getUserInfo().phone,
		// 	},
		// 	theme: {
		// 		color: "#61dafb",
		// 	},
		// };

		// const paymentObject = new window.Razorpay(options);
		// paymentObject.open();

		const data = {
			orderID: `ORDER_${Math.round(Date.now())}`,
			razorpayPaymentID: `RazorpayPaymentID_${Math.round(Date.now())}`,
			razorpayOrderID: `RazorpayOrderID_${Math.round(Date.now())}`,
			razorpaySignature: `RazorpaySignature_${Math.round(Date.now())}`,
		};

		// console.log(response);

		try {
			setEnrolling(true);
			await axios.post(`/courses/${params.courseID}/enroll`, data, config);
			setEnrolled(true);
			const result = await Swal.fire({
				icon: "success",
				title: "You're enrolled!",
				html: `You now have full access to <b>${course.name}</b>.`,
				confirmButtonText: "Start Learning",
				confirmButtonColor: "#293c74",
				showCancelButton: true,
				cancelButtonText: "Not now",
			});
			if (result.isConfirmed) {
				navigate(`/courses/${params.courseID}/view`);
			}
		} catch (e) {
			Swal.fire({
				icon: "error",
				title: "Enrollment failed",
				text:
					e.response?.data.message ||
					"Something went wrong. Please try again.",
				confirmButtonColor: "#293c74",
			});
		} finally {
			setEnrolling(false);
		}
	}

	const handleClick = () => {
		if (!auth.isAuthenticated()) {
			navigate("/auth/login", { state: { from: pathname }, replace: true });
		} else {
			displayRazorpay();
		}
	};

	// Curvet SDK easter egg: generate a byte-sized AI summary on demand (button-triggered
	// so we don't spend credits on every page load). Result is cached server-side.
	const handleSummarize = async () => {
		Swal.fire({
			html:
				'<div style="padding:6px 0;">' +
				'<div style="font-size:16px;font-weight:600;color:#1f2640;">Summarizing with AI…</div>' +
				'<div style="font-size:13px;color:#8a90a6;margin-top:6px;">Distilling this overview into byte-sized insights</div>' +
				"</div>",
			width: 420,
			allowOutsideClick: false,
			showConfirmButton: false,
			didOpen: () => Swal.showLoading(),
		});
		try {
			const res = await axios.get(
				`/courses/${params.courseID}/summary`,
				config
			);
			const summary = res.data.summary;
			if (!summary || !summary.length) {
				Swal.fire({
					icon: "info",
					title: "AI summary unavailable",
					text: "Summaries aren’t enabled right now.",
				});
				return;
			}
			const bullets = summary
				.map(
					(p) =>
						'<div style="display:flex;gap:10px;align-items:flex-start;padding:11px 13px;background:#f6f8fc;border:1px solid #eceff8;border-radius:10px;margin-bottom:9px;">' +
						'<span style="color:#293c74;font-size:13px;line-height:21px;">●</span>' +
						'<span style="font-size:14px;line-height:1.5;color:#2a2f45;text-align:left;">' +
						p +
						"</span></div>"
				)
				.join("");
			Swal.fire({
				width: 470,
				padding: "1.6rem 1.6rem 1.3rem",
				showConfirmButton: true,
				confirmButtonText: "Got it",
				confirmButtonColor: "#293c74",
				html:
					'<div style="text-align:left;">' +
					'<div style="display:flex;align-items:center;gap:9px;margin-bottom:3px;">' +
					'<span style="font-size:22px;">✨</span>' +
					'<span style="font-size:18px;font-weight:700;color:#1f2640;">Byte-sized summary</span>' +
					"</div>" +
					'<div style="font-size:12.5px;color:#8a90a6;margin:0 0 16px 31px;">AI-distilled key takeaways from this overview</div>' +
					bullets +
					'<div style="display:flex;align-items:center;justify-content:flex-end;gap:5px;margin-top:13px;font-size:11px;color:#aab0c4;">' +
					'Powered by <span style="font-weight:700;color:#293c74;">Curvet</span></div>' +
					"</div>",
			});
		} catch (e) {
			Swal.fire({
				icon: "error",
				title: "Something went wrong",
				text: e.response?.data?.message || "Could not generate summary",
			});
		}
	};

	useEffect(() => {
		window.addEventListener("scroll", (e) => {
			if (e.currentTarget.scrollY || e.currentTarget.scrollY > 90) {
				setIsOpaque(false);
			} else {
				setIsOpaque(true);
			}
		});

		// Engagement: a logged-in learner opened this course page. Powers the
		// "viewed but not enrolled" funnel in Course Analytics (no-ops if logged out).
		track("course_view", { course: params.courseID });

		axios
			.get(`/courses/${params.courseID}`, config)
			.then((res) => {
				// console.log(res.data);
				setCourse(res.data.course);
			})
			.catch((err) => console.log(err));

		// "You may also like": other non-draft courses, up to 3.
		axios
			.get(`/courses`)
			.then((res) => {
				setRelated(
					res.data.courses
						.filter(
							(c) => c._id !== params.courseID && c.status !== "draft"
						)
						.slice(0, 3)
				);
			})
			.catch((err) => console.log(err));

		axios
			.get(`/courses/${params.courseID}/checkEnrollment`, config)
			.then((res) => {
				if (res.data.status) {
					setEnrolled(true);
				}
			})
			.catch((err) => console.log(err));

		return () => {
			window.removeEventListener("scroll", (e) => {
				if (e.currentTarget.scrollY || e.currentTarget.scrollY > 90) {
					setIsOpaque(false);
				} else {
					setIsOpaque(true);
				}
			});
		};
	}, []);

	return (
		<IonPage>
			<div id="header_place">
				<Header isOpaque={isOpaque} />
			</div>
			<section id="hero_area3">
				<div className="center_wrapper">
					<div id="hero_area_details">
						<h1>{course.name}</h1>
						<p
							className="c-desc2"
							style={{
								display: "-webkit-box",
								WebkitLineClamp: 3,
								WebkitBoxOrient: "vertical",
								overflow: "hidden",
							}}
						>
							{course.description}
						</p>
						<br />
						<br />
						<div className="hero_details">
							<div>
								<p className="hero_detail_label">Time Commitment:</p>
								<p className="hero_detail">
									{course.timeCommitment || "7 days  (2 hr. per day)"}
								</p>
							</div>
							<div className="pre-req">
								<p className="hero_detail_label">Pre requisites:</p>
								<p className="hero_detail">{course.prerequisites || "None"}</p>
							</div>
						</div>
					</div>
					<div className="card details_card">
						<img
							src={
								course.thumbnail
									? mediaUrl(course.thumbnail)
									: `${process.env.PUBLIC_URL}/assets/c1.png`
							}
							alt={course.name || "Course"}
						/>
						<br />
						<br />
						{enrolled ? (
							<Link
								to={`/courses/${params.courseID}/view`}
								className="card_cta view_course"
								style={{ backgroundColor: "#F6D963" }}
							>
								View Course
							</Link>
						) : (
							<button
								onClick={handleClick}
								className="card_cta "
								disabled={enrolling}
							>
								{enrolling ? "Enrolling…" : "Enroll Now"}
							</button>
						)}
						<button className="card_cta card_cta_secondary">Save for Later</button>
						<br />
						<br />
						This course includes
						<br />
						{(course.includes && course.includes.length
							? course.includes
							: DEFAULT_INCLUDES
						).map((it, i) => (
							<div className="row" key={i}>
								<FontAwesomeIcon icon={INCLUDE_ICONS[it.icon] || faFileAlt} />
								<p>{it.label}</p>
							</div>
						))}
						<br />
						<hr />
						<div className="share_row">
							<span className="share_label">Share:</span>
							<a
								href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
									window.location.href
								)}`}
								target="_blank"
								rel="noreferrer"
								aria-label="Share on LinkedIn"
							>
								<img
									src={`${process.env.PUBLIC_URL}/assets/share_linkedin.svg`}
									alt="LinkedIn"
								/>
							</a>
							<a
								href={`https://wa.me/?text=${encodeURIComponent(
									window.location.href
								)}`}
								target="_blank"
								rel="noreferrer"
								aria-label="Share on WhatsApp"
							>
								<img
									src={`${process.env.PUBLIC_URL}/assets/share_whatsapp.svg`}
									alt="WhatsApp"
								/>
							</a>
							<a
								href="https://www.instagram.com/"
								target="_blank"
								rel="noreferrer"
								aria-label="Wyden on Instagram"
							>
								<img
									src={`${process.env.PUBLIC_URL}/assets/share_instagram.svg`}
									alt="Instagram"
								/>
							</a>
							<a
								href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
									window.location.href
								)}`}
								target="_blank"
								rel="noreferrer"
								aria-label="Share on Facebook"
							>
								<img
									src={`${process.env.PUBLIC_URL}/assets/share_facebook.svg`}
									alt="Facebook"
								/>
							</a>
							<button
								type="button"
								className="share_copy"
								onClick={copyCourseLink}
								aria-label="Copy course link"
								title="Copy link"
							>
								<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
									<path
										d="M10.5 13.5a4 4 0 0 0 5.66 0l3.34-3.34a4 4 0 1 0-5.66-5.66l-1.67 1.67M13.5 10.5a4 4 0 0 0-5.66 0L4.5 13.84a4 4 0 1 0 5.66 5.66l1.67-1.67"
										stroke="currentColor"
										strokeWidth="1.9"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</button>
							{linkCopied && (
								<span className="share_copied_note">Link copied!</span>
							)}
						</div>
					</div>
				</div>
			</section>

			<section id="course_details">
				<div className="center_wrapper">
					<div className="filter_tabs">
						<div
							className={activeTab === "overview" ? "tab_active" : ""}
							onClick={() => setActiveTab("overview")}
						>
							<span>Course Overview</span>
						</div>
						<div
							className={activeTab === "reviews" ? "tab_active" : ""}
							onClick={() => setActiveTab("reviews")}
						>
							<span>Reviews</span>
						</div>
					</div>
					{activeTab === "reviews" && (
						<div className="reviews">
							<p className="no_reviews">
								No reviews yet — be the first to review this course after
								completing it.
							</p>
						</div>
					)}
					<div
						className="course_overview_details"
						style={{ display: activeTab === "overview" ? "block" : "none" }}
					>
						{(course.overview || course.description || "")
							.split("\n\n")
							.map((paragraph, i) => (
								<p key={i}>{paragraph}</p>
							))}
						<div style={{ marginTop: "1.5rem" }}>
							<button
								onClick={handleSummarize}
								style={{
									display: "inline-flex",
									alignItems: "center",
									gap: "0.4rem",
									padding: "0.5rem 0.9rem",
									fontSize: "0.85rem",
									fontWeight: 600,
									color: "#293c74",
									background: "#fff",
									border: "1px solid #c7cfe2",
									borderRadius: "8px",
									cursor: "pointer",
								}}
							>
								✨ Summarize with AI
							</button>
						</div>
					</div>
				</div>
			</section>

			<section id="our_courses">
				<div className="center_wrapper">
					<h2 className="more-courses">You may also like</h2>
					<div className="courses_cards">
						{related.length === 0 ? (
							<div className="course_description" style={{ padding: 20 }}>
								No other courses yet.
							</div>
						) : (
							related.map((c) => (
								<div className="course" key={c._id}>
									<img
										src={
											c.thumbnail
												? mediaUrl(c.thumbnail)
												: `${process.env.PUBLIC_URL}/assets/c1.png`
										}
										alt={c.name}
									/>
									<div className="course_title">{c.name}</div>
									<div className="course_description">{c.description}</div>
									<div className="course_attributes">
										<div className="time">
											<svg
												className="time_icon"
												viewBox="0 0 24 24"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												aria-hidden="true"
											>
												<circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.6" />
												<path d="M12 7.5V12l3 2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
											</svg>
											{c.duration || "15 Min."}
										</div>
										<div className="inr">
											{c.currency || "INR"} {c.price}/-
										</div>
									</div>
									{c.status === "comingSoon" ? (
										<button disabled className="know_more coming_soon">
											Coming Soon
										</button>
									) : (
										<Link to={`/courses/${c._id}`} className="know_more">
											Know More
										</Link>
									)}
								</div>
							))
						)}
					</div>
				</div>
			</section>

			<div id="footer_place">
				<Footer />
			</div>
		</IonPage>
	);
};

export default CourseOverview;
